export const getFilteredWheelAlertItems = (
  items = [],
  activeTab = "All",
  vehicleSearch = "",
) => {
  if (!Array.isArray(items)) return [];

  const normalizedSearch = vehicleSearch?.trim().toLowerCase();

  let filteredItems = items;

  if (normalizedSearch) {
    filteredItems = filteredItems.filter((item) => {
      const vehicleNumber = `${item?.licensePlate || ""}`.toLowerCase();
      return vehicleNumber.includes(normalizedSearch);
    });
  }

  if (activeTab === "Alignment Due") {
    return filteredItems.filter((item) => item?.isAlignmentDone === false);
  }

  if (activeTab === "Balancing Due" || activeTab === "Balancing Done") {
    return filteredItems.filter((item) => item?.isBalancingDone === false);
  }

  return filteredItems;
};
